import { BubbleChat } from 'flowise-embed-react';

function App() {
  return (
    <div className="App">
      <BubbleChat
        chatflowid="8403c994-fe26-49a8-9780-4bdad9a5be64"
        apiHost="https://kraken.mythril.systems"
        theme={{    
          button: {
            show: false // Hide the floating button since we want the chat always open
          },
          chatWindow: {
            isOpen: true, // Force the chat window to be always open
            width: '80%', // Make it wider (80% of the viewport width)
            height: '90vh', // Make it taller (90% of the viewport height)
            maxWidth: '1200px', // Maximum width
            maxHeight: '900px', // Maximum height
            position: 'center', // Center the chat window
            margin: 'auto', // Center align
            top: '50%', // Center vertically
            left: '50%', // Center horizontally
            transform: 'translate(-50%, -50%)', // Perfect centering
            showTitle: false,
            showAgentMessages: true,
            title: '',
            titleAvatarSrc: '',
            welcomeMessage: 'Hello! How can I help you today?',
            errorMessage: 'Sorry, something went wrong. Please try again later.',
            backgroundColor: '#ffffff',
            overflow: 'hidden',
            fontSize: 16,
            starterPrompts: [
              "What is a bot?",
              "Who are you?"
            ],
            starterPromptFontSize: 15,
            clearChatOnReload: false,
            sourceDocsTitle: 'Sources:',
            renderHTML: true,
            botMessage: {
              backgroundColor: '#f7f8ff',
              textColor: '#303235',
              showAvatar: false,
              avatarSrc: ''
            },
            userMessage: {
              backgroundColor: '#454c5c',
              textColor: '#ffffff',
              showAvatar: false,
              avatarSrc: ''
            },
            textInput: {
              placeholder: 'Type your question',
              backgroundColor: '#ffffff',
              textColor: '#303235',
              sendButtonColor: '#454c5c',
              maxChars: 50,
              maxCharsWarningMessage: 'You exceeded the characters limit. Please input less than 50 characters.',
              autoFocus: true,
              sendMessageSound: true,
              receiveMessageSound: true
            },
            feedback: {
              color: '#303235'
            },
            dateTimeToggle: {
              date: true,
              time: true
            },
            footer: {
              textColor: '#303235',
              text: 'Powered by',
              company: 'Mythril Kraken',
              companyLink: 'https://mythril.systems'
            }
          }
        }}
      />
    </div>
  );
}

export default App;
